import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '../store/authStore'

/**
 * Syncs i18next language to the worker's preferred_language or language_code.
 * Call once in App.tsx.
 */
export function useI18nSync() {
  const { i18n } = useTranslation()
  const worker = useAuthStore((s) => s.worker)

  useEffect(() => {
    const lang = worker?.preferred_language || worker?.language_code
    if (lang) {
      const supported = ['ru', 'en', 'uz']
      const code = supported.includes(lang) ? lang : 'ru'
      if (i18n.language !== code) {
        i18n.changeLanguage(code)
      }
    }
  }, [worker?.preferred_language, worker?.language_code, i18n])
}
